import React from 'react';
import { Beneficiary, beneficiaryDefaults } from './schema';

interface BeneficiariesEditorProps {
  value: Beneficiary[];
  onChange: (next: Beneficiary[]) => void;
  error?: string;
}

export function BeneficiariesEditor({ value, onChange, error }: BeneficiariesEditorProps) {
  const updateAt = (index: number, patch: Partial<Beneficiary>) => {
    const next = value.map((b, i) => (i === index ? { ...b, ...patch } : b));
    onChange(next);
  };

  const removeAt = (index: number) => {
    onChange(value.filter((_, i) => i !== index));
  };

  const add = () => {
    onChange([...value, { ...beneficiaryDefaults }]);
  };

  return (
    <div className="mb-3">
      <div className="d-flex justify-content-between align-items-center mb-2">
        <strong>Beneficiarios</strong>
        <button type="button" className="btn btn-sm btn-outline-primary" onClick={add}>
          + Agregar beneficiario
        </button>
      </div>

      {value.length === 0 && (
        <div className="alert alert-warning py-2 small mb-2">
          Agregá al menos un beneficiario.
        </div>
      )}

      {value.map((b, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <div key={index} className="card mb-2">
          <div className="card-body py-2">
            <div className="row g-2 align-items-end">
              <div className="col-md-4">
                <label className="form-label small mb-1" htmlFor={`ben-dob-${index}`}>
                  Fecha de nacimiento
                </label>
                <input
                  id={`ben-dob-${index}`}
                  type="date"
                  className="form-control form-control-sm"
                  value={b.date_of_birth}
                  onChange={(e) => updateAt(index, { date_of_birth: e.target.value })}
                />
              </div>
              <div className="col-md-3">
                <label className="form-label small mb-1" htmlFor={`ben-dur-${index}`}>
                  Duración (años)
                </label>
                <input
                  id={`ben-dur-${index}`}
                  type="number"
                  min={1}
                  className="form-control form-control-sm"
                  value={b.duration_years}
                  onChange={(e) => updateAt(index, { duration_years: Number(e.target.value) })}
                  onWheel={(e) => e.currentTarget.blur()}
                />
              </div>
              <div className="col-md-3">
                <label className="form-label small mb-1" htmlFor={`ben-tuit-${index}`}>
                  Arancel anual (UF)
                </label>
                <input
                  id={`ben-tuit-${index}`}
                  type="number"
                  min={0}
                  step={0.01}
                  className="form-control form-control-sm"
                  value={b.annual_tuition}
                  onChange={(e) => updateAt(index, { annual_tuition: Number(e.target.value) })}
                  onWheel={(e) => e.currentTarget.blur()}
                />
              </div>
              <div className="col-md-2 d-flex justify-content-end">
                <button
                  type="button"
                  className="btn btn-sm btn-outline-danger"
                  onClick={() => removeAt(index)}
                  disabled={value.length === 1}
                  title={value.length === 1 ? 'Debe haber al menos un beneficiario' : 'Eliminar'}
                >
                  Eliminar
                </button>
              </div>
            </div>
          </div>
        </div>
      ))}

      {error && <div className="text-danger small">{error}</div>}
    </div>
  );
}
